import React, { useEffect, useState } from "react";
import "./Header.css";
// import Logo from './../Assets/logo.jpeg';
import Logo from "./logo-removebg-preview.png";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import AOS from "aos";
import "aos/dist/aos.css";
import LinearProgress from "@mui/material/LinearProgress";
import { useLocation } from "react-router-dom";
const Header = ({ setType }) => {
  const [progress, setProgress] = useState(0);
  const location = useLocation();
  const [pathName, setPathName] = useState();

  // console.log(location.pathname)

  useEffect(() => {
    AOS.init({
    duration: 2000,
    once: true
    });
    }, []);

  useEffect(() => {
    // setPathName(location.pathname);
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 100;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <section className="res-height">
      {["lg"].map((expand) => (
        <Navbar
        //  fixed={location.pathname=="/"?"top":null}
          key={expand}
          bg="white"
          expand={expand}
          style={{
          // boxShadow: location.pathname=="/"?'0px 0px 5px 1px #e9ecef':null,
           backgroundColor: "#fffff", padding: "0px 17px" }}
        >
          <Container fluid>
            <Navbar.Brand>
              <Link
                to="/"
                // data-aos="zoom-in"
                // data-aos-duration="1500"
                // data-aos-easing="ease-in-out"
                // data-aos-once="true"
              >
                {" "}
                <img src={Logo} className="headerIcon" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <Link to="/">
                    <img src={Logo} className="headerIcon" />
                  </Link>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3 brand-nav-link">
                  <Nav.Link>
                    <Link to="/">Home</Link>
                  </Nav.Link>
                  <Nav.Link>
                    <Link to="/search">Search</Link>
                  </Nav.Link>
                  <Nav.Link>
                    <Link to="/myfleet">My Fleet</Link>
                  </Nav.Link>
                  <Nav.Link>
                    <Link to="/contact">Contact</Link>
                  </Nav.Link>
                  <Nav.Link>
                    <Link to="/login">Login</Link>
                  </Nav.Link>
                  <Nav.Link>
                    <Link to="/register">SignUp</Link>
                  </Nav.Link>
                  <Nav.Link>
                    <Link to="/assets">List an asset</Link>
                  </Nav.Link>

                  {/* <NavDropdown
                    title="Dropdown"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action4">
                      Another action
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action5">
                      Something else here
                    </NavDropdown.Item>
                  </NavDropdown> */}
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}

      {/* {
      progress==100
      ?
       <LinearProgress variant="determinate" value={progress} />
    :null} */}
    </section>
  );
};

export default Header;
